import { DevAccountButton } from "../../authentication/DevAccounts";
import { DEV_ACCOUNT_TANCIS, DEV_ACCOUNT_TANOGA } from "./Dev_Accounts";
import { DEV_ACCOUNT_TANESW } from "../../authentication/Dev_Accounts_ESW";

export const LoginFooter = () => {
    return (
        <div className="text-[#999999] bg-background rounded-b-3xl flex items-center justify-center h-20">
            <div className="px-1 text-center">Copyright © 2025 Tanzania Revenue Authority. All rights reserved.</div>
        </div>
    );
};
